import React from 'react';
import SharedInsuranceForm from '../InsuranceForm';
import SharedInsurerDocsUploadField from '../InsurerDocsUploadField';
import { CUSTOMER_INSURANCE_DOCUMENTS_UPLOAD_URL } from '@/config';

const LoadCustomerInsuranceForm: React.FC<{ open?: any }> = ({ open }) => {
  const LoadCustomerInsurerDocsUpload = () => (
    <SharedInsurerDocsUploadField 
      uploadUrl={CUSTOMER_INSURANCE_DOCUMENTS_UPLOAD_URL}
      borderStyle="1px"
      iconSize={40}
      typographyVariant="body1"
      listItemStyles={{
        pb: 0,
        pt: 0,
        avatarMinWidth: 'auto',
        avatarWidth: 32,
        avatarHeight: 32
      }}
    />
  );

  return <SharedInsuranceForm open={open} InsurerDocsUploadComponent={LoadCustomerInsurerDocsUpload} />;
};

export default LoadCustomerInsuranceForm;
